// Human review time must not exhaust the wizard's request watchdog.
export function createPausableTimeout(handler, delay, subscribePaused, {
  now = Date.now, setTimer = setTimeout, clearTimer = clearTimeout
} = {}) {
  let remaining = delay;
  let timer = null;
  let armedAt = 0;
  let done = false;
  let unsubscribe;
  function cancel() {
    done = true;
    if (timer !== null) clearTimer(timer);
    unsubscribe?.();
  }
  unsubscribe = subscribePaused(paused => {
    if (done) return;
    if (timer !== null) {
      clearTimer(timer);
      remaining = Math.max(0, remaining - (now() - armedAt));
      timer = null;
    }
    if (!paused) {
      armedAt = now();
      timer = setTimer(() => { cancel(); handler(); }, remaining);
    }
  });
  return cancel;
}
